// ============================================================================
// Padrao de preenchimento do SAAS.GL (item 14 da etapa de refinamento)
// ----------------------------------------------------------------------------
// Modulo unico e compartilhado. Antes os formatadores viviam soltos dentro de
// Clientes.js, o que obrigaria a duplicar tudo em Agendamentos.js e OS.js --
// tres copias para manter em sincronia. Aqui existe uma definicao so.
//
// Formatacao de ENTRADA: o valor sai do campo ja no formato final, e e assim
// que fica gravado. Nao e efeito visual de CSS.
//
// COMO USAR
//   import { fmt } from "../services/formato";
//   <input value={form[campo]}
//          onChange={e=>setForm(f=>({...f,[campo]:fmt(campo,e.target.value)}))} />
//
// O mapa e indexado pelo NOME DO CAMPO, e os nomes se repetem entre as telas
// (telefone, cpf, placa, km...). Por isso a mesma chamada serve para Clientes,
// Agendamentos e OS sem mapa proprio em cada arquivo. Campo que nao esta no
// mapa passa sem alteracao -- e assim que os textos livres ficam de fora.
// ============================================================================

export function soDigitos(v) {
  return String(v == null ? "" : v).replace(/\D/g, "");
}

export function caixaAlta(v) {
  return String(v == null ? "" : v).toUpperCase();
}

// (11) 74125-8963  /  (11) 7412-5896
// Idempotente: remascarar um valor ja formatado devolve o mesmo resultado --
// necessario porque a edicao recarrega no campo o valor ja gravado.
export function mascaraTelefone(v) {
  const d = soDigitos(v).slice(0, 11);
  if (d.length === 0) return "";
  if (d.length <= 2) return d;
  if (d.length <= 6) return "(" + d.slice(0, 2) + ") " + d.slice(2);
  if (d.length <= 10) return "(" + d.slice(0, 2) + ") " + d.slice(2, 6) + "-" + d.slice(6);
  return "(" + d.slice(0, 2) + ") " + d.slice(2, 7) + "-" + d.slice(7);
}

// 147.753.259-15  /  12.345.678/0001-90
export function mascaraCpfCnpj(v) {
  const d = soDigitos(v).slice(0, 14);
  if (d.length <= 11) {
    if (d.length <= 3) return d;
    if (d.length <= 6) return d.slice(0, 3) + "." + d.slice(3);
    if (d.length <= 9) return d.slice(0, 3) + "." + d.slice(3, 6) + "." + d.slice(6);
    return d.slice(0, 3) + "." + d.slice(3, 6) + "." + d.slice(6, 9) + "-" + d.slice(9);
  }
  if (d.length <= 5) return d.slice(0, 2) + "." + d.slice(2);
  if (d.length <= 8) return d.slice(0, 2) + "." + d.slice(2, 5) + "." + d.slice(5);
  if (d.length <= 12) return d.slice(0, 2) + "." + d.slice(2, 5) + "." + d.slice(5, 8) + "/" + d.slice(8);
  return d.slice(0, 2) + "." + d.slice(2, 5) + "." + d.slice(5, 8) + "/" + d.slice(8, 12) + "-" + d.slice(12);
}

// 00/00/0000 -- entrada de data por digitacao
export function mascaraData(v) {
  const d = soDigitos(v).slice(0, 8);
  if (d.length <= 2) return d;
  if (d.length <= 4) return d.slice(0, 2) + "/" + d.slice(2);
  return d.slice(0, 2) + "/" + d.slice(2, 4) + "/" + d.slice(4);
}

// 00:00
export function mascaraHora(v) {
  const d = soDigitos(v).slice(0, 4);
  if (d.length <= 2) return d;
  return d.slice(0, 2) + ":" + d.slice(2);
}

const manter = (v) => String(v == null ? "" : v);

// ----------------------------------------------------------------------------
// FORA DA CAIXA ALTA, de proposito:
//
//   email  -- regra do proprio pedido: nao aplicar cegamente em e-mails, URLs,
//             identificadores, codigos e dados tecnicos.
//
//   textos livres (relato do cliente, observacoes) -- nao entram no mapa. Sao
//             narrativa, nao dado de identificacao; em caixa alta ficam
//             dificeis de ler no orcamento impresso e no relatorio. Para
//             inclui-los, basta adicionar a chave aqui.
//
// PLACA vai so para caixa alta, SEM mascara de hifen: OS, agendamento e
// orcamento comparam placa como texto cru, e passar a gravar "ABC-1D23" faria
// os registros existentes ("ABC1D23") deixarem de casar.
// ----------------------------------------------------------------------------
export const FMT = {
  // Pessoa -- os nomes variam por tela, todos mapeados
  nome:               caixaAlta,
  cliente:            caixaAlta,
  cliente_nome:       caixaAlta,
  telefone:           mascaraTelefone,
  cpf:                mascaraCpfCnpj,
  email:              manter,
  endereco:           caixaAlta,

  // Veiculo
  placa:              caixaAlta,
  modelo:             caixaAlta,
  veiculo:            caixaAlta,
  cor:                caixaAlta,
  ano:                (v) => soDigitos(v).slice(0, 4),
  km:                 (v) => soDigitos(v).slice(0, 7),

  // Servico e equipe
  tecnico:            caixaAlta,
  servico_solicitado: caixaAlta,
  categoria:          caixaAlta,
  fornecedor:         caixaAlta,

  // Data e hora
  data:               mascaraData,
  data_agendamento:   mascaraData,
  hora:               mascaraHora,
  horario:            mascaraHora,
};

// Campo ausente do mapa passa sem alteracao.
export const fmt = (campo, valor) => (FMT[campo] || ((x) => x))(valor);

export default fmt;

// ============================================================================
// Data e hora do agendamento
// ----------------------------------------------------------------------------
// A coluna agendamentos.data_agendamento e TIMESTAMP. O usuario digita no
// padrao brasileiro (00/00/0000 e 00:00), mas o que vai para o banco precisa
// ser ISO -- "25/12/2026" enviado cru quebra o parse do Postgres, que leria o
// mes primeiro. Estas funcoes fazem a ponte nos dois sentidos.
// ============================================================================

// "09/09/2026" + "14:30" -> "2026-09-09T14:30:00"   (sem data valida -> null)
export function paraISO(dataBR, horaBR) {
  const d = soDigitos(dataBR);
  if (d.length !== 8) return null;
  const dia = d.slice(0, 2), mes = d.slice(2, 4), ano = d.slice(4);
  const h = soDigitos(horaBR);
  const hh = h.length >= 2 ? h.slice(0, 2) : "00";
  const mm = h.length >= 4 ? h.slice(2, 4) : "00";
  if (Number(mes) < 1 || Number(mes) > 12 || Number(dia) < 1 || Number(dia) > 31) return null;
  if (Number(hh) > 23 || Number(mm) > 59) return null;
  return ano + "-" + mes + "-" + dia + "T" + hh + ":" + mm + ":00";
}

// "2026-09-09T14:30:00" -> { data:"09/09/2026", hora:"14:30" }
export function deISO(iso) {
  if (!iso) return { data: "", hora: "" };
  const s = String(iso);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);
  if (!m) return { data: "", hora: "" };
  return { data: m[3] + "/" + m[2] + "/" + m[1], hora: m[4] ? m[4] + ":" + m[5] : "" };
}

// Para exibicao curta: "09/09/2026 as 14:30"
export function exibirDataHora(iso) {
  const { data, hora } = deISO(iso);
  if (!data) return "";
  return hora ? data + " as " + hora : data;
}

// Agendamento cuja data ja passou e que ainda nao andou no fluxo.
export function estaAtrasado(iso) {
  if (!iso) return false;
  const t = new Date(iso).getTime();
  return !Number.isNaN(t) && t < Date.now();
}

// "2026-12-25T08:00:00" -> "Sexta, 25 de dezembro de 2026 as 08:00"
// Confirmacao por extenso: quem digita 12/05 e 05/12 trocados percebe na hora
// pelo dia da semana, antes de salvar.
const DIAS_SEMANA = ["Domingo","Segunda","Terca","Quarta","Quinta","Sexta","Sabado"];
const MESES = ["janeiro","fevereiro","marco","abril","maio","junho",
               "julho","agosto","setembro","outubro","novembro","dezembro"];
export function exibirDataExtenso(iso) {
  if (!iso) return "";
  const dt = new Date(iso);
  if (Number.isNaN(dt.getTime())) return "";
  const { hora } = deISO(iso);
  const base = DIAS_SEMANA[dt.getDay()] + ", " + dt.getDate() + " de " +
               MESES[dt.getMonth()] + " de " + dt.getFullYear();
  return hora ? base + " as " + hora : base;
}

// ============================================================================
// Valor em dinheiro
// ----------------------------------------------------------------------------
// Digitacao da direita para a esquerda, como em caixa e maquininha: os digitos
// entram pelos centavos e empurram para a esquerda. Digitar 1 2 3 4 5 produz
// 0,01 -> 0,12 -> 1,23 -> 12,34 -> 123,45. E o que o operador espera, e evita
// o erro classico de digitar "150" e gravar R$ 1,50 (ou R$ 150,00 sem querer).
// ============================================================================

export function mascaraMoeda(v) {
  const d = soDigitos(v).slice(0, 11); // teto de R$ 999.999.999,99
  if (!d) return "";
  const n = Number(d) / 100;
  return n.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// "1.234,56" -> 1234.56   |   vazio/invalido -> 0
export function moedaParaNumero(v) {
  const d = soDigitos(v);
  return d ? Number(d) / 100 : 0;
}

// 1234.56 -> "1.234,56"  (para preencher o campo a partir de um valor salvo)
export function numeroParaMoeda(n) {
  const x = Number(n);
  if (!Number.isFinite(x)) return "";
  return x.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
